export enum FileExtensionCategory {
  ARCHIVE = 'archive',
  AUDIO = 'audio',
  DOCUMENT = 'document',
  FOLDER = 'folder',
  IMAGE = 'image',
  PDF = 'pdf',
  SPREADSHEET = 'spreadsheet',
  VIDEO = 'video'
}